module.exports = __webpack_public_path__ + "static/ad4-569a5a08dcdffb122443f6d8217793cb.svg";